import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "members" }
const _hoisted_2 = { class: "search-bar input-group" }
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("em", { class: "bi bi-arrow-clockwise text-white" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "d-flex justify-content-around align-items-center gap-3 border border-primary border-3 border-start-0 rounded-end-4 rounded-bottom-0 px-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("em", { class: "bi bi-exclamation-circle text-white" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("em", { class: "bi bi-lock text-white" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("em", { class: "bi bi-dash-circle text-white" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "users-table table-responsive mt-2 mb-3" }
const _hoisted_14 = { class: "table table-hover table-admin overflow-hidden rounded-1" }
const _hoisted_15 = { class: "table-registry border-3 border-primary" }
const _hoisted_16 = { class: "align-middle" }
const _hoisted_17 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "fw-bold m-0 text-white" }
const _hoisted_20 = { class: "d-flex flex-column" }
const _hoisted_21 = ["fill"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("path", { d: "m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" }, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["fill"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("path", { d: "M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" }, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "overflow-hidden border-3 border-primary border-top-0 border-bottom-0 rounded-1" }
const _hoisted_28 = { class: "d-flex align-items-center justify-content-start py-1" }
const _hoisted_29 = { class: "my-auto" }
const _hoisted_30 = ["id", "value", "checked", "onChange"]
const _hoisted_31 = { class: "text-start m-0" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  type: "button",
  id: "button-addon2"
}, [
  /*#__PURE__*/_createElementVNode("em", { class: "bi bi-three-dots text-white" })
], -1)
const _hoisted_33 = { class: "dropdown-menu mx-1" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("li", { class: "text-start my-1" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "dropdown-item",
    type: "button"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bar-chart-fill text-start" }, " View Statistics")
  ])
], -1)
const _hoisted_35 = { class: "text-start my-1" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-circle" }, " Warn", -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "text-start my-1" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-lock" }, " Suspend", -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "text-start my-1" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-dash-circle" }, " Delete", -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { class: "m-0" }
const _hoisted_48 = { class: "m-0" }
const _hoisted_49 = {
  key: 1,
  class: "align-middle border-3 border-start-0 border-end-0 border-primary"
}
const _hoisted_50 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        type: "text",
        class: "form-control border-3 border-primary bg-transparent text-white rounded-end-0 rounded-top-4 px-4 py-3",
        placeholder: "Search here...",
        id: "searchBar",
        value: _ctx.searchText,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSearchText($event.target.value)))
      }, null, 40, _hoisted_3),
      _createElementVNode("button", {
        class: "btn btn-outline-primary border-start-0 border-3 px-4",
        type: "button",
        id: "button-addon2",
        onClick: _cache[1] || (_cache[1] = 
          () => {
            _ctx.setSearchText('');
            _ctx.$emit('resetSelected');
          }
        )
      }, _hoisted_5),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          ref: "warn",
          role: "button",
          class: "link-white link-opacity-75-hover",
          "data-bs-toggle": "modal",
          "data-bs-target": "#actionsModal",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleModal('Warn')))
        }, _hoisted_8, 512),
        _createElementVNode("a", {
          ref: "suspend",
          role: "button",
          class: "link-white link-opacity-75-hover",
          "data-bs-toggle": "modal",
          "data-bs-target": "#actionsModal",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleModal('Suspend')))
        }, _hoisted_10, 512),
        _createElementVNode("a", {
          ref: "delete",
          role: "button",
          class: "link-white link-opacity-75-hover",
          "data-bs-toggle": "modal",
          "data-bs-target": "#actionsModal",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleModal('Delete')))
        }, _hoisted_12, 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("table", _hoisted_14, [
        _createElementVNode("thead", _hoisted_15, [
          _createElementVNode("tr", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
              return (_openBlock(), _createElementBlock("th", {
                key: index,
                class: "sorting-column py-2",
                scope: "col"
              }, [
                (header.key !== 'actions')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn w-100 d-flex flex-row align-items-center justify-content-center gap-3",
                        onClick: ($event: any) => (_ctx.setFilterBy(header.key)),
                        ref_for: true,
                        ref: `sortBy${
                    header.key.charAt(0).toUpperCase() + header.key.slice(1)
                  }`
                      }, [
                        _createElementVNode("p", _hoisted_19, _toDisplayString(header.label), 1),
                        _createElementVNode("div", _hoisted_20, [
                          (_openBlock(), _createElementBlock("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "14",
                            height: "14",
                            fill: 
                        _ctx.filterBy === header.key && _ctx.ascending
                          ? '#6ef997'
                          : '#adb5bd'
                      ,
                            class: "bi bi-caret-up-fill",
                            viewBox: "0 0 16 16"
                          }, _hoisted_23, 8, _hoisted_21)),
                          (_openBlock(), _createElementBlock("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "14",
                            height: "14",
                            fill: 
                        _ctx.filterBy === header.key && !_ctx.ascending
                          ? '#6ef997'
                          : '#adb5bd'
                      ,
                            class: "bi bi-caret-down-fill",
                            viewBox: "0 0 16 16"
                          }, _hoisted_26, 8, _hoisted_24))
                        ])
                      ], 8, _hoisted_18)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_27, [
          (_ctx.filteredUsers.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filteredUsers, (member, idx) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: member.memberId,
                  class: "align-middle border-3 border-start-0 border-end-0 border-primary"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (header.key === 'name')
                        ? (_openBlock(), _createElementBlock("td", {
                            key: index,
                            class: "py-4"
                          }, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("input", {
                                  class: "form-check-input mx-4",
                                  type: "checkbox",
                                  id: `checkbox-${idx}`,
                                  value: member,
                                  checked: _ctx.selectedUsers.includes(member),
                                  onChange: ($event: any) => (_ctx.toggleCheckbox(member))
                                }, null, 40, _hoisted_30)
                              ]),
                              _createElementVNode("p", _hoisted_31, _toDisplayString(member[header.key]), 1)
                            ])
                          ]))
                        : (header.key === 'actions')
                          ? (_openBlock(), _createElementBlock("td", {
                              key: index,
                              class: "text-center"
                            }, [
                              _hoisted_32,
                              _createElementVNode("ul", _hoisted_33, [
                                _hoisted_34,
                                _createElementVNode("li", _hoisted_35, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    role: "button",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#actionsModal",
                                    onClick: ($event: any) => (_ctx.runSingleAction(member, 'Warn'))
                                  }, _hoisted_38, 8, _hoisted_36)
                                ]),
                                _createElementVNode("li", _hoisted_39, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    role: "button",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#actionsModal",
                                    onClick: ($event: any) => (_ctx.runSingleAction(member, 'Suspend'))
                                  }, _hoisted_42, 8, _hoisted_40)
                                ]),
                                _createElementVNode("li", _hoisted_43, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    role: "button",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#actionsModal",
                                    onClick: ($event: any) => (_ctx.runSingleAction(member, 'Delete'))
                                  }, _hoisted_46, 8, _hoisted_44)
                                ])
                              ])
                            ]))
                          : (header.key === 'verified')
                            ? (_openBlock(), _createElementBlock("td", {
                                key: index,
                                class: "text-center py-4"
                              }, [
                                _createElementVNode("p", _hoisted_47, _toDisplayString(member[header.key] === true ? "Yes" : "No"), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("td", {
                                key: index,
                                class: "text-center py-4"
                              }, [
                                _createElementVNode("p", _hoisted_48, _toDisplayString(member[header.key]), 1)
                              ]))
                    ], 64))
                  }), 256))
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("tr", _hoisted_49, [
                _createElementVNode("td", {
                  class: "py-3",
                  colspan: _ctx.headers.length
                }, "No users found.", 8, _hoisted_50)
              ]))
        ])
      ])
    ])
  ]))
}